import { useModal } from '@ebay/nice-modal-react';
import { useCallback } from 'react';

import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';
import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

import { LocationSelectorModal } from './location-selector-modal.component';
import { useLocalOffersLocationContext } from '../context';
import { LocationSelectorState } from './location-selector-modal.types';

export const LocationSelectorModalController = () => {
  const { visible, hide, remove } = useModal();
  const { locationState, customLocation, setNoLocationFilter, requestCurrentLocation } =
    useLocalOffersLocationContext();

  const { triggerEvent } = useRudderStack();

  const handleSelectLocation = useCallback(
    (newLocationState: LocationSelectorState) => {
      if (newLocationState === 'nearby') {
        triggerEvent('local_offers_nearby_offers_clicked');
        requestCurrentLocation();
        hide();
      } else if (newLocationState === 'all') {
        triggerEvent('local_offers_all_offers_clicked');
        setNoLocationFilter();
        hide();
      }
    },
    [setNoLocationFilter, requestCurrentLocation, hide, triggerEvent],
  );

  const { pushToLocalOffersLocationSearch } = useGetNavigationActions();
  const handleSearchForLocationClick = useCallback(() => {
    triggerEvent('local_offers_search_for_location_clicked');
    hide();
    pushToLocalOffersLocationSearch();
  }, [hide, pushToLocalOffersLocationSearch, triggerEvent]);

  return (
    <LocationSelectorModal
      open={visible}
      onClose={hide}
      onExited={remove}
      locationState={locationState}
      customLocationName={customLocation?.name}
      onSelectLocation={handleSelectLocation}
      onSearchForLocationClick={handleSearchForLocationClick}
    />
  );
};
